export const environment = {
  production: true,
  buildId: '2822678790419401',
  configFile: 'config.json',
};
